// Central catalog of PostHog event names.
//
// Event names have historically been string literals scattered across 25+
// components, with no single place to see what we track or guard against typos
// and drift (e.g. `job_favorited` vs `job_favorited_click`). New and migrated
// capture sites import names from here; call sites not yet migrated still use
// posthog.capture() with literals. Values are the snake_case names already in
// PostHog — do not rename without a migration, or historical data will split.

export const EVENTS = {
  // --- Job browsing (candidate) ---
  JOB_LISTING_CLICK: 'job_listing_click',
  JOB_DETAIL_VIEW: 'job_detail_view',
  JOB_FAVORITED: 'job_favorited',
  JOB_RATING_EDIT_CLICK: 'job_rating_edit_click',
  APPLICATION_SUBMITTED: 'application_submitted',
  FAVORITES_TOGGLED: 'favorites_toggled',

  // --- Filtering & search ---
  PROFESSION_FILTER_CHANGED: 'profession_filter_changed',
  SPECIALTY_FILTER_CHANGED: 'specialty_filter_changed',
  FILTER_APPLIED: 'filter_applied',
  FILTER_CLEARED: 'filter_cleared',
  FILTER_CLEARED_ALL: 'filter_cleared_all',
  FILTER_SAVED: 'filter_saved',
  SAVED_FILTER_SELECTED: 'saved_filter_selected',
  SAVED_FILTER_CLEARED: 'saved_filter_cleared',

  // --- Candidate AI assistant (Stethi) ---
  AI_CHAT_OPENED: 'ai_chat_opened',
  AI_CHAT_MESSAGE_SENT: 'ai_chat_message_sent',
  AI_CHAT_SUGGESTION_CLICK: 'ai_chat_suggestion_click',
  AI_CHAT_STOPPED: 'ai_chat_stopped',
  AI_CHAT_CLEARED: 'ai_chat_cleared',
  AI_CHAT_FEEDBACK_VOTED: 'ai_chat_feedback_voted',
  AI_CHAT_FEEDBACK_SUBMITTED: 'ai_chat_feedback_submitted',

  // --- Smart upload ---
  SMART_UPLOAD_DRAWER_CLOSED: 'smart_upload_drawer_closed',
  SMART_UPLOAD_URLS_SUBMITTED: 'smart_upload_urls_submitted',
  SMART_UPLOAD_COMPLETED: 'smart_upload_completed',

  // --- Employer: candidate matching & AI ---
  EMPLOYER_CANDIDATE_AI_CHAT_OPENED: 'employer_candidate_ai_chat_opened',
  EMPLOYER_CANDIDATE_AI_MESSAGE_SENT: 'employer_candidate_ai_message_sent',
  EMPLOYER_CANDIDATE_AI_SUGGESTION_CLICKED: 'employer_candidate_ai_suggestion_clicked',
  EMPLOYER_CANDIDATE_AI_REQUEST_STOPPED: 'employer_candidate_ai_request_stopped',
  EMPLOYER_CANDIDATE_AI_CONVERSATION_CLEARED: 'employer_candidate_ai_conversation_cleared',
  EMPLOYER_CANDIDATE_AI_FEEDBACK_VOTED: 'employer_candidate_ai_feedback_voted',
  EMPLOYER_CANDIDATE_AI_FEEDBACK_SUBMITTED: 'employer_candidate_ai_feedback_submitted',
  EMPLOYER_CANDIDATE_AI_MESSAGE_FEEDBACK_VOTED: 'employer_candidate_ai_message_feedback_voted',
  EMPLOYER_CANDIDATE_AI_MESSAGE_FEEDBACK_SUBMITTED: 'employer_candidate_ai_message_feedback_submitted',
  EMPLOYER_CANDIDATE_MATCH_ROW_CLICKED: 'employer_candidate_match_row_clicked',
  EMPLOYER_CANDIDATE_MATCHES_VIEW_FULL_LIST_CLICKED: 'employer_candidate_matches_view_full_list_clicked',
  EMPLOYER_CANDIDATE_AI_CARD_CLICKED: 'employer_ai_candidate_card_clicked',
  EMPLOYER_CANDIDATE_RESUME_DOWNLOADED: 'employer_candidate_resume_downloaded',
  EMPLOYER_PROFILE_PHOTO_UPLOADED: 'employer_profile_photo_uploaded',

  // --- Employer: jobs management ---
  EMPLOYER_JOB_VIEW_CLICKED: 'employer_job_view_clicked',
  EMPLOYER_JOB_EDIT_CLICKED: 'employer_job_edit_clicked',
  EMPLOYER_JOB_SELECTED_IN_TABLE: 'employer_job_selected_in_table',
  EMPLOYER_JOB_FORM_SUBMITTED: 'employer_job_form_submitted',
  EMPLOYER_JOBS_STATUS_FILTER_CHANGED: 'employer_jobs_status_filter_changed',
  EMPLOYER_VIEW_MODE_CHANGED: 'employer_view_mode_changed',
}

export default EVENTS
